/*
* buildDataBindSyntax
* Takes in an array of bind syntax
* OR
* Takes in one object of bind syntax
* OR
* Takes in a value to be bound to
* OR
* Takes in null
*
* binds - list of objects OR an Object OR a string OR null
* type - type of the object being bound (EX: label, input, etc.)
*
*/
export function buildDataBindSyntax(binds, type?) {
    if (!binds) {
        return null;
    }

    if ($.isPlainObject(binds)) {
        binds = [binds];
    }

    if ($.isArray(binds)) {
        var bindValue = "";
        $.each(binds, function (index, curBind) {
            if (bindValue.length > 0) {
                bindValue += ", ";
            }
            bindValue += `${curBind.type}: ${curBind.value}`;
        });
        return bindValue;
    } else if ($.type(binds) == "string") {
        switch (type) {
            case "input":
                return `value: ${binds}`;
            case "container":
                return `visible: ${binds}`;
            case "date":
                return `date: ${binds}`;
            case "dateTime":
                return `dateTime: ${binds}`;
            case "customText":
                return `customText: ${binds}`;
            case "localizedText":
                return `localizedText: ${binds}`;
            case "booleanText":
                return `booleanText: ${binds}`;
            case "time":
                return `time: ${binds}`;
            case "absoluteTime":
                return `absoluteTime: ${binds}`;
            case "signature":
                return `signature: ${binds}`;
            case "url":
                return `url: ${binds}`;
            case "label":
            default:
                return `text: ${binds}`;
        }
    }

    return null;
}
